import React from 'react';
import AgeSelect from '../component/ageSelect';
import CheckBox from '../component/checkBoxWorkScan';

let checkBoxDataEnglish = {
  ch2: "I have long term health problem(eg: diabetes or hypertension or COPD)",
  tag2: "longTermHealthProblems",
  ch3: "No, I do not have any long term health problem",
  tag3: "HealthRisksNone",
  sub: "Submit"
}

let questions = [
  {
    id: '1',
    message: 'Enter your name',
    trigger:'NameInputQuery'
  },
  {
    id: 'NameInputQuery',
    user: true,
    waitAction: true,
    trigger:'2'
  },
  {
    id: '2',
    message: 'Hi {previousValue}, Enter you official email address',
    trigger:'EmailInputQuery'
  },
  {
    id: 'EmailInputQuery',
    user: true,
    waitAction: true, 
    trigger:'3'
  },
  {
    id: '3',
    message: 'Enter your phone number',
    trigger:'PhoneInputQuery'
  },
  {
    id: 'PhoneInputQuery',
    user: true,
    waitAction: true,
    trigger:'4'
  },
  {
    id: '4',
    message: 'Enter your corporate name',
    trigger:'CorporateNameQuery'
  },
  {
    id: 'CorporateNameQuery',
    user: true,
    waitAction: true,
    trigger:'5'
  },
  {
    id: '5',
    message: 'What is your age?',
    trigger: 'englishage',
  },
  {
    id: 'englishage',
    component: <AgeSelect />,
    waitAction: true,
    trigger: '6',
  },
  {
    id: '6',
    message: 'Please select your gender',
    trigger: 'englishgender',
  },
  {
    id: 'englishgender',
    options: [
      { value: 'male', label: 'Male', trigger: '7' },
      { value: 'female', label: 'Female', trigger: '7' },
    ],
  },
  {
    id: '7',
    message: 'Do you have cough, runny nose (cold), sorethroat, fever/ flu symptoms at present?',
    trigger: 'englishSymptomsQuery',
  },
  {
    id: 'englishSymptomsQuery',
    options: [
      { value: 'Yes, I have one or more of these', label: 'Yes, I have one or more of these', trigger: '8' },
      { value: 'No, I do not have any of these', label: 'No, I do not have any of these', trigger: '8' },
    ],
  },
  {
    id: '8',
    message: 'Have you travelled outside the country in the last 30 days?',
    trigger: 'englishTravelExposureQuery',
  },
  {
    id: 'englishTravelExposureQuery',
    options: [
      { value: 'Yes, I have travelled recently', label: 'Yes, I have travelled recently', trigger: '9' },
      { value: 'No, I have not travelled recently', label: 'No, I have not travelled recently', trigger: '9' },
    ],
  },
  {
    id: '9',
    message: 'Have you come in close contact with someone who is diagnosed with coronavirus(Covid-19) or is suspected to have it? Close contact means someone you live with or work closely with.',
    trigger: 'englishCaseExposureQuery',
  },
  {
    id: 'englishCaseExposureQuery',
    options: [
      { value: 'Yes, I have', label: 'Yes, I have', trigger: '10' },
      { value: 'No, I have not', label: 'No, I have not', trigger: '10' },
    ],
  },
  {
    id: '10',
    message: 'Are you from Containment area?',
    trigger: 'ContainmentAreaQuery',
  },
  {
    id: 'ContainmentAreaQuery',
    options: [
      { value: 'Yes', label: 'Yes, I am', trigger: '11' },
      { value: 'No', label: 'No, I am not', trigger: '11' },
    ],
  },
  {
    id: '11',
    message: 'You or Any family members suffering from flu/ Diabetes/ Respiratory disorders/Cardiac disorders?',
    trigger: 'DisorderQuery',
  },
  {
    id: 'DisorderQuery',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '12' },
      { value: 'No', label: 'No', trigger: '12' },
    ],
  },{
    id: '12',
    message: 'You or Any of the family members are suffering from immune suppressant disorders?',
    trigger: 'SuppressantDisorderQuery',
  },
  {
    id: 'SuppressantDisorderQuery',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '13' },
      { value: 'No', label: 'No', trigger: '13' },
    ],
  },
  {
    id: '13',
    message: 'Are you on any anti hypertensive drugs/ blood thinners?',
    trigger: 'DrugQuery',
  },
  {
    id: 'DrugQuery',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '14' },
      { value: 'No', label: 'No', trigger: '14' },
    ],
  },
  {
    id: '14',
    message: 'Have you gone to any of the mass gathering places in recent 14 days?',
    trigger: 'MassGatheringQuery',
  },
  {
    id: 'MassGatheringQuery',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '15' },
      { value: 'No', label: 'No', trigger: '15' },
    ],
  },
  {
    id: '15',
    message: ' Have you travelled to your home town or any other places during lock down?',
    trigger: 'TravelQuery',
  },
  {
    id: 'TravelQuery',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '16' },
      { value: 'No', label: 'No', trigger: '16' },
    ],
  },
  {
    id: '16',
    message: 'Please select one!',
    trigger: 'englishHealthRisksQuery',
  },
  {
    id: 'englishHealthRisksQuery',
    component: <CheckBox checkBoxData={checkBoxDataEnglish}/>,
    waitAction: true,
    end: true
  }
]
export default questions